









import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Types
import { IMetaData } from "@/models/metaData";

@Component
export default class InvoiceMetaData extends Vue {
  // Props

  @Prop({ required: true })
  public invoiceMetaData!: IMetaData;

  // Computed

  public get metaData() {
    return _.map(this.invoiceMetaData, (value, key) => {
      return { value, key };
    });
  }

  public get hasMetaData() {
    return !_.isEmpty(this.metaData);
  }
}
